import React, { createContext, useContext, memo, useState, useEffect, Fragment } from 'react';
import { BehaviorSubject } from 'rxjs';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';

export enum GCApp {
  agency,
  management,
}

export interface GCAppContextData {
  app: GCApp;
  setApp(app: GCApp): void;
}

// export const AppContext = createContext<GCAppContextData>({ app: GCApp.agency, setApp: () => R.noop() });
export const AppContext = createContext<GCApp>(GCApp.agency);

export function useAppContext() {
  return useContext(AppContext);
}

export const appContext$ = new BehaviorSubject<GCApp>(GCApp.agency);

export const AppContextProvider = memo(({ children }: any) => {
  const [app, setApp] = useState(GCApp.agency);
  const appFromObs = useNonNilObservable(appContext$);

  useEffect(() => {
    setApp(appFromObs);
  }, [appFromObs]);

  return <AppContext.Provider value={app}>{children}</AppContext.Provider>;
});

export const GCAppContext = memo(({ children }: any) => {
  const app = useAppContext();
  if (app === GCApp.agency) {
    return <Fragment>{children}</Fragment>;
  }
  return null;
});

export const GMAppContext = memo(({ children }: any) => {
  const app = useAppContext();
  if (app === GCApp.management) {
    return <Fragment>{children}</Fragment>;
  }
  return null;
});
